import React from 'react'
import { Form, Field, FormikProps } from 'formik'
import { IGroupInput } from '../../types/group'
import { debouncedGetEditorRoleSuggestions } from '../../services/typeahead'
import { StyledFormActionWrapper, WrapContainer } from '../../layouts'
import {
  Button,
  H2,
  P2,
  CustomTextField,
  DateAuthorFragment,
  TypeaheadSelect,
  CustomCheckboxField,
} from '../../components'

export interface IGroupForm {
  formikProps: FormikProps<IGroupInput>
  submitText: string
  cancelAction?: () => void
  nameDisabled?: boolean
  editable?: boolean
}

export const GroupForm = ({
  formikProps,
  submitText = 'Submit',
  cancelAction,
  nameDisabled,
  editable = true,
}: IGroupForm) => (
  <Form>
    <H2 mb={4}>Enter metadata and save</H2>
    <Field
      name="name"
      label="Group name"
      component={CustomTextField}
      helperText="Will be used in the link to this group—you won't be able to change it later"
      changeValue={(value) => value.toLowerCase()}
      disabled={nameDisabled || !editable}
    />
    <Field
      name="shortTitle"
      label="Short title"
      component={CustomTextField}
      disabled={!editable}
    />
    <Field
      name="title"
      label="Full title"
      component={CustomTextField}
      disabled={!editable}
    />
    <Field
      name="description"
      label="Group description"
      component={CustomTextField}
      multiline
      disabled={!editable}
    />
    <Field
      name="editorRole"
      label="Editor role"
      placeholder="Find and select a role"
      component={TypeaheadSelect}
      loadOptions={debouncedGetEditorRoleSuggestions}
      disabled={!editable}
    />
    <H2 mb={4}>Specify file upload limit</H2>
    <WrapContainer contains={2}>
      <Field
        name="maxFileSizeMb"
        label="Upload limit"
        component={CustomTextField}
        type="number"
        endAdornment="MB"
        disabled={!editable}
      />
    </WrapContainer>
    <H2 mb={4}>Hide group</H2>
    <P2>
      Hidden groups won't be visible in Consumer portal. Only these users who
      have permission to this hidden group could access it. You, however, still
      will be able to access this group and change this setting later.
    </P2>
    <Field
      name="hidden"
      id="hidden-group"
      component={CustomCheckboxField}
      label="Hide this group"
      disabled={!editable}
    />
    <DateAuthorFragment {...formikProps.values} />
    <StyledFormActionWrapper>
      {cancelAction && (
        <Button id="cancel-button" onClick={cancelAction}>
          Cancel
        </Button>
      )}
      <Button
        id="submit-form-data"
        type="submit"
        variant="contained"
        color="primary"
        disabled={!formikProps.isValid || !editable}
      >
        {submitText}
      </Button>
    </StyledFormActionWrapper>
  </Form>
)
